export default ({ FONT_SIZES }) => ({
  img: {
    height: '200px',
    width: '200px'
  }
})
